import { useEffect, useState } from "react";
import * as util from "../Helpers/Util";
import queryString from "query-string";
import history from "../../history";
import createBasvuruWithAltSurecList from "../../services/createBasvuruWithAltSurecList";
import createBasvuruWithAltSurec from "../../services/createBasvuruWithAltSurec";
import ebEventEkle from "../../services/ebEventEkle";
import { Form, Select, Col, Button, Row, Spin } from "antd";
const { Option } = Select;

const parsed = queryString.parse(history.location.search);

const formItemStyle = {
  marginLeft: 20,
  marginTop: 20
};

const CreateBasvuruForm = () => {
  const [form] = Form.useForm();
  const [spining, setSpining] = useState(false);
  const [raportorList, setRaportorList] = useState([]);
  const [raportorIdList, setRaportorIdList] = useState([]);
  const [defaultIdList, setDefaultIdList] = useState([]);

  const loadForm = async () => {
    setSpining(true);
    await createBasvuruWithAltSurecList(parsed.basvuruId)
      .then((resp) => {
        if (resp.data.success) {
          setRaportorList(resp.data.result);
          let defaultList = resp.data.result.filter((x) => x.zorunluMu === true).map((y) => y.raportorAltSurecTipiId);
          setDefaultIdList(defaultList);
          setRaportorIdList(defaultList);
        } else {
          util.errorMessage(resp.data.message);
        }
      })
      .catch((ex) => {
        util.errorMessage(String(ex.message));
      });
    setSpining(false);
  };
  useEffect(() => {
    loadForm();
  }, []);

  const onFinish = async () => {
    setSpining(true);

    if (raportorIdList.length == 0) {
      util.errorMessage("En az bir müellif seçimi zorunludur.");
      setSpining(false);
    } else {
      let data = [];
      let filterModel = {};

      raportorIdList.map((key) => {
        filterModel = {};
        filterModel.altSurecTipiId = key;
        filterModel.relAltSurecTipiId = parsed.altSurecTipiId;
        filterModel.parentObjectId = parsed.parentObjectId;
        data.push(filterModel);
      });

      await createBasvuruWithAltSurec(data)
        .then((resp) => {
          if (!resp.data.success) {
            util.errorMessage(resp.data.message);
            setSpining(false);
          } else {
            if (!util.isNullOrEmptyOrUndefined(parsed.eventName)) {
              let ebManualEventRequest = {
                basvuruId: parsed.basvuruId,
                eventName: parsed.eventName,
              };
              ebEventEkle(ebManualEventRequest);
              setSpining(false);
            } else {
              util.successMessage(resp.data.message);
              setSpining(false);
            }

            window.parent.parent.location.reload();
          }
        })
        .catch((ex) => {
          setSpining(false);
          util.errorMessage(String(ex.message));
        });
    }
    // setSpining(false);
  };

  return (
    <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
      <Form form={form} onFinish={onFinish}>
        <Col span={20}>
          <Form.Item
            label="Görev Alacak Müellifler"
            name="raportorIdList"
            style={formItemStyle}
            labelAlign="left"
          >
            {
              <Select
                mode="tags"
                placeholder="Müellifler"
                defaultValue={defaultIdList}
                key={defaultIdList}
                onChange={(val) => setRaportorIdList(val)}
              >
                {raportorList &&
                  raportorList.map((bt) => (
                    <Option
                      key={bt.raportorAltSurecTipiId}
                      value={bt.raportorAltSurecTipiId}
                      label={bt.editorAdi}
                      disabled={bt.zorunluMu == true}
                    >
                      {bt.editorAdi}
                    </Option>
                  ))}
              </Select>
            }
          </Form.Item>
        </Col>
        <Row>
          <Col span={20} style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              Tamamla
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default CreateBasvuruForm;
